module.exports = __webpack_public_path__ + "static/media/Bandit-Screenshot-1.a01b82d7.png";